export { default } from './makeStyles';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/styles/esm/makeStyles/index.js
// module id = 472
// module chunks = 121